import React, { useContext, useState ,useEffect} from "react";
import IPODialog from "./IPODialog";
import { Context } from "../../services/apiContext";
import configData from "../../utils/config/config.json";
import { useNotificationActionsContext } from "../../components/notificationModal/useModal";
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

const IPODpClientID = ({
    sendCreatedFolio,
    value
}) => {
    const setNotifi = useNotificationActionsContext();
    const contextapi = useContext(Context);
    useEffect(() => {
        getDepositorData();
    },[]);
    // console.log(selectedList)
    const [selectedList, setselectedList] = useState(value);
    const selectedDetails = (e, value) =>{
        console.log(value)
       sendCreatedFolio(value.dpid+value.client_id)
    }
    const [searchList, setsearchList] = useState([]);

    const getDepositorData = async () => {
        var useData = contextapi.getSession("userData").user_key;
        var panToken = contextapi.getSession("userData").pan;

        var postData = {
          data: {
            user_key: useData,
            pan: panToken
          },
          url: configData.baseURLDev + "/user/getclientids",
        };
       
        var url = configData.baseURLProxy;
    await contextapi
      .postApiAuthCalling(url, postData, false)
          .then((res) => {
              console.log(res.data[0])
            if (res.msg === "sucess") {
                if (res.data[0].clids !== null) {
                    if (res.data[0].clids.length > 0) {
                      var depositerName = res.data[0].clids;
                      var depositerlist = [];
        
                      depositerName.forEach((element) => {
                        let newData = {};
                        if(element.depo == 'C'){
                            // newData.dpid = element.dpid;
                            newData.client_id = element.client_id;
                            if(element.dpname != ""){
                                newData.label = element.client_id +"-"+element.dpname;
                            }else {
                                newData.label = element.client_id ;
                            }
                                if(value != '' && value == element.client_id){
                                    setselectedList(newData.label)
                                }
                        }else {
                            newData.dpid = element.dpid;
                            newData.client_id = element.client_id;
                            newData.label = element.dpid +"-"+element.client_id +"-"+element.dpname;
                            
                        }
                       
                        depositerlist.push(newData);
                     
                        if(value != '' && value == element.client_id){
                            setselectedList(newData.label)
                        }
                    });
                    
                    setsearchList(depositerlist);
                    }
                }
            }
          })
          .catch((error) => {
            // console.log(error);
            // setNotifi({ val: true, msg: "Something went wrong" });
          });
      };

      
    const [dpId, setdpId] = useState('')
    const [clientId, setclientId] = useState('');
    const handledipId = (e) => {
        setdpId(e.target.value)
    }
    const handleclientId = (e) => {
        setclientId(e.target.value)
    }

    const openInvestor = () =>{
        setopenDialog(true);
    }

    const [openDialog, setopenDialog] = useState(false)
    const closestatus = (that)=>{
        setopenDialog(false);
       
    }

    const showView = () =>{
        switch (openDialog) {
            case false:
                return (
                   <></>
                )
            case true:
                return (
                    <IPODialog openstatus={openDialog} closestatus={closestatus} confirmationName={'investorList'} TitleName='INVESTOR DETAILS'/>
                )
        }

    }

    return (
        <div className="row paddingZero">

            <div className="col-lg-8 col-md-8 col-8 ">

            <Autocomplete
             value={selectedList}
            onChange={(event, value) => selectedDetails(event, value)} 
      disablePortal
      id="combo-box-demo"
      options={searchList}
      sx={{ 
        width:{
            xs: 300,
            sm: 500
        }}}
      renderInput={(params) => <TextField {...params} label="INVESTOR DETAILS" />}
    />
                {/* <input type="text" value={dpId} autoComplete="off"
                    onChange={handledipId}
                    className=" form-control dpidInput" id='dpid' name="dpid" placeholder="DP ID" /> */}
            </div>

            {/* <div className="col-lg-6 col-md-6 col-6 ">

                <input type="text" value={clientId} autoComplete="off"
                    onChange={handleclientId}
                    className=" form-control dpidInput" id='clientid' name="clientid" placeholder="Client ID" />
            </div> */}

            {/* <div>
                <button onClick={() => openInvestor()}>Select Investor</button>
            </div> */}
        {
            showView()
        }
            
        </div>


    )
}

export default IPODpClientID;